module.exports = ___sgwt_webpack_dll___highcharts_v7;